import React from "react"
import thunkMiddleware from "redux-thunk"
// import { createLogger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension"
import { BrowserRouter as Router } from "react-router-dom"
import { Provider } from "react-redux"
import { createStore, applyMiddleware } from "redux"
import rootReducer from "./reducers"
import Home from "./pages/Home"

// const loggerMiddleware = createLogger({ collapsed: true });

const store = createStore(
  rootReducer as any,
  composeWithDevTools(applyMiddleware(thunkMiddleware))
)

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Home />
      </Router>
    </Provider>
  )
}

export default App
